import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
  view: null,
  customSize: "320px",
  size: "sm",
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openModal: (state, action) => {
      const { view, customSize, size } = action.payload;
      state.isOpen = true;
      state.view = view;
      state.customSize = customSize || state.customSize;
      state.size = size || state.size;
    },
    closeModal: (state) => {
      state.isOpen = false;
    },
  },
});

export const { openModal, closeModal } = modalSlice.actions;
export default modalSlice.reducer;
